import { actionTextColor } from "../utils/themeContrast";
import { lightTint, readableText } from "../utils/themeContrast";
/* eslint-disable no-console */
import React, { useState, useEffect } from "react";

import { Link, navigate } from "@reach/router";
import styled from "@emotion/styled";
import useWindowDimensions from "../hooks/useWindowDimensions";
import axios from "axios";
import moment from 'moment';
import Modal from "../newcomponents/optioncomponents/Modal";
import AdvocadoLogin from '../newcomponents/advocadoComponents/AdvocadoLogin';
import AdvocadoCredit from '../newcomponents/advocadoComponents/AdvocadoCredit';
import CheckoutPanel from "../newcomponents/CheckoutPanel";
import CheckoutRecommendationItems from "../newcomponents/CheckoutRecommendationItems";
import AddItemModal from "../newcomponents/AddItemModal";
import ConfirmCheckOutModal from '../newcomponents/optioncomponents/ConfirmCheckoutModal';
import TakeAwayModal from '../newcomponents/optioncomponents/TakeAwayModal';
import DeliveryOrNotModal from '../newcomponents/optioncomponents/DeliveryOrNotModal';
import PaymentTypeModal from '../newcomponents/optioncomponents/PaymentTypeModal'
import { IoIosArrowBack } from "react-icons/io";
import promo from '../newcomponents/customerComponents/Promotion';
import { UserContext, ActionContext, ThemeContext, LanguageContext } from "../contexts/Context";
import EditItemModal from '../newcomponents/EditItemModal';
import TableInfo from '../newcomponents/CheckOutInfo/TableInfo';
import PreOrderInfo from '../newcomponents/CheckOutInfo/PreOrderInfo';
import ReserveInfo from "../newcomponents/CheckOutInfo/ReserveInfo";
import VoucherField from '../newcomponents/customerComponents/VoucherField';
import OrderLoading from "../newcomponents/OrderLoading";
import { getUnavailableCartItems } from "../utils/menuAvailability";
import { getCheckoutPricing, getOrderContact, readStoredJSON, savePendingOrder } from '../utils/pendingOrder';

const getOptionSelectionKey = (optionArray = []) => JSON.stringify(optionArray.map((group) => ({
  optionTitle: group.optionTitle,
  options: (group.options || []).map((option) => ({
    codeId: option.codeId,
    title: option.title,
    active: Boolean(option.active),
    qty: option.qty || 0,
    optionArray: option.optionArray ? JSON.parse(getOptionSelectionKey(option.optionArray)) : []
  }))
})));

const Checkout = () => {
  const [show, setShow] = useState(false); //warning dialog
  const [showConfirm, setShowConfirm] = useState(false); //display dialog to show submit confirmation
  const [showTk, setShowTk] = useState(false); //display dialog to input cusomter detail
  const [showDelive, setShowDelive] = useState(false); //display dialog to choose delivery or pickup
  //0 is TakeAway  1 is Dine in
  const [deliveryType, setDeliveryType] = useState(0); //user select delivery or pickup or dinein
  const [deliveryPrice, setDeliveryPrice] = useState(0); //display delivery | pickup option
  const [showPayment, setShowPayment] = useState(false); //display dialog to choose paynow or later
  const [payType, setPayType] = useState(-1); //user select paynow or pay later
  const [error, setError] = useState([]);
  const [showEdit, setShowEdit] = useState(false);
  const [isStockCheck, setStockCheck] = useState(false);
  const [editIndex, setEditIndex] = useState(0);
  const [editItem, setEditItem] = useState(null);
  const [checkoutRecommendation, setCheckoutRecommendation] = useState(null);
  const [recommendedItem, setRecommendedItem] = useState(null);
  const [showRecommendedItem, setShowRecommendedItem] = useState(false);
  const { height, width } = useWindowDimensions();
  const checkoutWidth = width >= 768 ? Math.min(420, width * 0.92) : Math.min(550, width);

  const [room, setRoom] = useState("");
  const [phone, setPhone] = useState("");
  const [name, setName] = useState("");

  const [isLoading, setLoading] = useState(false);

  const [showAdvocadoLogin, setShowAdvocadoLogin] = useState(false);
  const [showAdvocadoCredit, setShowAdvocadoCredit] = useState(false);


  //Context
  const {
    pax,
    cart,
    token,
    userId,
    orderTime,
    company,
    tax,
    paymentData,
    isTakeAway,
    hasPayment,
    paymentPlatform,
    checkStockBeforeCheckOut,
    isDemo,
    lanIndex,
    isLanReverse,
    currencySymbol,
    allowTAafterWH,
    startTime,
    endTime,
    otherUrls,
    deliveryOrNot,
    deliveryCosts,
    minimumConsumption,
    PaymentTakeawayOnly,
    haveToPayOnline,
    isOnlinePayMinConsumption,
    onlinePayMinConsumptionVal,
    includeDineIn,
    tkDiMenuDiff,
    tkType,
    adCustomer,
    hasTakeAway,
    customer,
    redeem,
    discount,
    finalOrder,
    skipDIPickUpTime,
    skipTAPickUpTime,
    skipCustomerDetail,
    reserveData,
    hidePrice,
    pm,
    payAtCounter,
    hasVoucher,
    advocadoRedeem,
    vouchers,
    deliveryCalMethod,
    deliveryDisAmt,
    deliverySpend,
    containerItems,
    isInRoom,
    takeAwayInfo,
    selectPUTimeFirst,
    advocadoStoreCredit,
    displayNetAmount,
    memberRedeem,
    takeAwayAllowAtCounter,
    hasFomoPay,
    additionalPickUpTime,
    isPreOrder
  } = React.useContext(UserContext);

  const { clearCart, removeFromCart, addToCart, setReserveData, setFinalOrder, setRedeem, setDiscount, addPromotion, addPayType, addPostal, payByAdvocado, addTakeAwayInfo, setTkType } = React.useContext(ActionContext);
  const themeContext = React.useContext(ThemeContext);
  const language = React.useContext(LanguageContext);

  const { ready: pricingReady, serviceCharge, finalAmount } = getCheckoutPricing(
    cart, "", tax, paymentData, isTakeAway, deliveryType
  );
  const bcrsNo = promo.getBCRSNo(cart, isTakeAway, deliveryType);
  const canSubmit = pricingReady && Number.isFinite(deliveryPrice) &&
    Number.isFinite(finalAmount + deliveryPrice);

  useEffect(() => {
    // Browser back and other checkout links bypass PaymentSummary's back handler.
    const hasRewards = (redeem && redeem.length > 0) || discount ||
      cart.some((item) => item.hasSpecialDiscount) ||
      (pm && pm.some((promotion) => promotion.customerRewardId));
    if (!hasRewards) return;

    const newPromo = (pm || []).filter((promotion) => !promotion.customerRewardId);
    let newCart = JSON.parse(JSON.stringify(cart)).filter((item) => !item.autoAddedReward);
    for (const item of newCart) {
      item.hasSpecialDiscount = false;
      item.specialDiscount = 0;
      item.specialDiscountAmount = 0;
      item.specialDiscountRemark = "";
    }
    newCart = promo.applyPromotion(newPromo, promo.clearPromotion(newCart));

    setRedeem([]);
    setDiscount(null);
    addPromotion(newPromo);
    addToCart(newCart);
    localStorage.setItem("order", JSON.stringify(newCart));

    const savedOrder = finalOrder || readStoredJSON("finalOrder");
    if (savedOrder) {
      const newFinalOrder = { ...savedOrder, data: newCart, discount: null, redeem: [] };
      setFinalOrder(newFinalOrder);
      localStorage.setItem("finalOrder", JSON.stringify(newFinalOrder));
    }
    // Rewards are only applied on payment summary; reset once on checkout entry.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [subtotal, setSubtotal] = useState(promo.subTotalAmount(cart));
  const [defaulAmount, setDefaultAmount] = useState(promo.subTotalDefaultAmount(cart));
  const isEnabled = (value) => value === true || value === "true" || value === 1 || value === "1";
  const shouldSkipPickUpForm = (deliveryType) => {
    return !isPreOrder && (
      (deliveryType == 1 && isEnabled(skipDIPickUpTime) && isEnabled(skipCustomerDetail)) ||
      (deliveryType == 0 && isEnabled(skipTAPickUpTime))
    );
  };

  useEffect(() => {

    let checkinTime = localStorage.getItem("checkIn");
    if (checkinTime) {
      let diff = (new Date().getTime() - checkinTime) / 1000 / 60 / 60;

      if (diff > 1) {
        window.location.replace(otherUrls && otherUrls.length > 0 ? otherUrls[0].url : "https://google.com");
      }
    }

    if (isTakeAway && !allowTAafterWH) {
      let stime = moment(startTime);
      let etime = moment(endTime);
      let tdyTxt = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      let day = new Date().getDay();
      let st = moment().set("hour", stime.get("hour")).set("minute", stime.get("minute"));
      let et = moment().set("hour", etime.get("hour")).set("minute", etime.get("minute"));
      if (stime.get("hour") < etime.get('hour')) {
        et = et.add(24, "hour");
      }
      if (moment().isBefore(st) || moment().isAfter(et)) {
        let isMatch = false;
        for (let pk of additionalPickUpTime) {
          if (pk.weekDays && pk.weekDays.indexOf(tdyTxt[day]) > -1) {
            stime = moment(pk.startTime);
            etime = moment(pk.endTime);
            st = moment().set("hour", stime.get("hour")).set("minute", stime.get("minute"));
            et = moment().set("hour", etime.get("hour")).set("minute", etime.get("minute"));

            if (moment().isAfter(st) && moment().isBefore(et)) {
              isMatch = true;
              break;
            }
          }
        }
        if (!isMatch)
          window.location.replace(otherUrls && otherUrls.length > 0 ? otherUrls[0].url : "https://google.com");
      }
    }
  }, [isTakeAway, paymentData]);

  // Pricing refreshes must not reset the customer's selected service type.
  useEffect(() => {
    if (isTakeAway) {
      setDeliveryType(tkType);
    } else if (tkType == 4) {
      setDeliveryType(4);
    }
  }, [isTakeAway, tkType]);

  /********
   * EDIT ITEM FUNCTION
   * ********************* */
  //Remove from cart
  const handleDelete = (cart, index) => {
    cart.splice(index, 1);
    if (pm && pm.length > 0) {
      cart = promo.applyPromotion(pm, promo.clearPromotion(cart));
    }
    cart = promo.applyContainer(promo.removeContainer(cart), containerItems, isTakeAway && tkType != 1);
    localStorage.setItem("order", JSON.stringify(cart));
    removeFromCart(cart, index);
    setDefaultAmount(promo.subTotalDefaultAmount(cart));
    setSubtotal(promo.subTotalAmount(cart));

  };

  //add from cart
  const handleAdd = (cart, index) => {
    cart[index].qty += 1;
    if (cart[index].qty == 0) {
      cart.splice(index, 1);
    }

    if (pm && pm.length > 0) {
      cart = promo.clearPromotion(cart);
      cart = promo.applyPromotion(pm, cart);
    }


    cart = promo.removeContainer(cart);
    cart = promo.applyContainer(cart, containerItems, isTakeAway && tkType != 1);


    localStorage.setItem("order", JSON.stringify(cart));
    removeFromCart(cart, index);

    setDefaultAmount(promo.subTotalDefaultAmount(cart));
    setSubtotal(promo.subTotalAmount(cart));

  }

  const handleItemClick = (item, index) => () => {
    setEditIndex(index);
    setEditItem(JSON.parse(JSON.stringify(item)));
    setShowEdit(true);
  };

  useEffect(() => {
    if (!token) return;

    let cancelled = false;
    axios.post("/v2/api/selforder/checkout/recommendation", { cart }, {
      headers: { Authorization: "Bearer " + token }
    })
      .then((response) => {
        if (cancelled) return;
        const recommendation = response.data;
        if (recommendation && Array.isArray(recommendation.options) && recommendation.options.length > 0) {
          setCheckoutRecommendation(recommendation);
        } else {
          setCheckoutRecommendation(null);
        }
      })
      .catch((error) => {
      
      });

    return () => {
      cancelled = true;
    };
  }, [token]);

  const addRecommendedItemToCart = (configuredItem) => {
    const newItem = JSON.parse(JSON.stringify(configuredItem));
    newItem.optionArray = Array.isArray(newItem.optionArray) ? newItem.optionArray : [];
    newItem.recommendedArray = Array.isArray(newItem.recommendedArray) ? newItem.recommendedArray : [];
    newItem.qty = newItem.qty > 0 ? newItem.qty : 1;
    newItem.remark = newItem.remark || "";
    newItem.recommendId = "MREC";

    let newCart = JSON.parse(JSON.stringify(cart));
    const optionKey = getOptionSelectionKey(newItem.optionArray);
    const matchingItem = newCart.find((item) =>
      item.codeId === newItem.codeId &&
      (item.remark || "") === newItem.remark &&
      Boolean(item.isTakeAway) === Boolean(newItem.isTakeAway) &&
      getOptionSelectionKey(item.optionArray || []) === optionKey
    );

    if (matchingItem) {
      matchingItem.qty += newItem.qty;
    } else {
      newCart.push(newItem);
    }

    if (pm && pm.length > 0) {
      newCart = promo.clearPromotion(newCart);
      newCart = promo.applyPromotion(pm, newCart);
    }
    newCart = promo.removeContainer(newCart);
    newCart = promo.applyContainer(newCart, containerItems, isTakeAway && tkType != 1);

    localStorage.setItem("order", JSON.stringify(newCart));
    addToCart(newCart);
    setShowRecommendedItem(false);
    setRecommendedItem(null);
  };

  const handleRecommendedItemClick = (item) => {
    const selectedItem = JSON.parse(JSON.stringify(item));
    selectedItem.optionArray = Array.isArray(selectedItem.optionArray) ? selectedItem.optionArray : [];
    selectedItem.recommendedArray = Array.isArray(selectedItem.recommendedArray) ? selectedItem.recommendedArray : [];
    selectedItem.qty = 1;
    selectedItem.remark = selectedItem.remark || "";
    selectedItem.recommendId = "MREC";

    if (selectedItem.optionArray.length > 0) {
      setRecommendedItem(selectedItem);
      setShowRecommendedItem(true);
      return;
    }

    addRecommendedItemToCart(selectedItem);
  };

  const handleMinus = (cart, index) => {
    cart[index].qty -= 1;


    if (cart[index].qty == 0) {
      cart.splice(index, 1);
    } else if (cart[index].minQty > 0 && cart[index].qty < cart[index].minQty) {
      cart.splice(index, 1);
    }
    if (pm && pm.length > 0) {
      cart = promo.clearPromotion(cart);
      cart = promo.applyPromotion(pm, cart);
    }


    cart = promo.removeContainer(cart);
    cart = promo.applyContainer(cart, containerItems, isTakeAway && tkType != 1);

    localStorage.setItem("order", JSON.stringify(cart));

    removeFromCart(cart, index);
    setDefaultAmount(promo.subTotalDefaultAmount(cart));
    setSubtotal(promo.subTotalAmount(cart));

  }




  const notAllowToCheck = () => {
    setError([{
      errorElement: "No Item Selected",
      errorMessage: (
        <b style={{ color: "#CF000D" }}>{language[lanIndex].pleaseSelectItem}</b>
      )
    }])
    setShow(true);

  }
  const minimumConsumptionTip = () => {
    setError([{
      errorMessage: (
        <b style={{ color: "#CF000D" }}>{`${language[lanIndex].minimumConsumptionTip} ${minimumConsumption}`} </b>
      )
    }])
    setShow(true);

  }

  const getItemTitle = (item) => {
    return (lanIndex == 0 && !isLanReverse) || (lanIndex == 1 && isLanReverse) ?
      item.title :
      (item.title2 ? item.title2 : item.title);
  };

  const validateCartAvailability = (scheduleTime, orderItems = cart) => {
    const unavailableItems = getUnavailableCartItems(orderItems, scheduleTime);
    if (unavailableItems.length == 0) return true;

    setError([{
      errorElement: "Item unavailable",
      errorMessage: (
        <b style={{ color: "#CF000D" }}>
          {`Some items are not available at ${moment(scheduleTime).format("DD/MM HH:mm")}: ${unavailableItems.map(getItemTitle).join(", ")}`}
        </b>
      )
    }]);
    setShow(true);
    return false;
  };

  const sendOrder = async () => {
    if (!canSubmit) return;
    //check if demo
    if (isDemo) return;
    if (checkStockBeforeCheckOut && !isStockCheck) {
      await axios.post("/v2/api/selfOrder/stockCheck", { data: cart }, { headers: { Authorization: "Bearer " + token } })
        .then(async function (response) {
          if (response.status == 200) {
            setStockCheck(true);
          } else if (response.status == 202) {
            let errorMsg = [];
            for (let msg of response.data.message) {
              errorMsg.push({
                errorElement: "Insufficient Stock",
                errorMessage: (
                  <b style={{ color: "#CF000D" }}>{msg}</b>
                )
              });
            }
            setError(errorMsg);
            setShow(true);
          }
        })
        .catch(function (e) {
          setError([
            {
              errorElement: "Check Stock Error",
              errorMessage: (
                <b style={{ color: "#CF000D" }}>{e}</b>
              )
            }
          ]);
          setShow(true);
        });
      return;
    }
    //check if has item
    if (cart.length == 0) {
      notAllowToCheck();
      return;
    }

    if (isTakeAway || isInRoom || isPreOrder) { //TakeAway
      if (hasPayment && !isPreOrder) { //check if has exceed min. spending amt
        if (isOnlinePayMinConsumption && subtotal < onlinePayMinConsumptionVal) {
          setError([{
            errorElement: language[lanIndex].belowMinSpendning,
            errorMessage: (
              <b style={{ color: "#CF000D" }}>{language[lanIndex].belowMinSpending2}<br />
                {language[lanIndex].belowMinSpending3 + " " + currencySymbol + onlinePayMinConsumptionVal.toFixed(2)}</b>
            )
          }])
          setShow(true);
          return;
        }
      }
      if (!isPreOrder && advocadoStoreCredit) {
        setShowPayment(true);
        return;
      }

      let takeAwayDeliveryType = takeAwayInfo && (takeAwayInfo.deliveryType || takeAwayInfo.deliveryType == 0) ? takeAwayInfo.deliveryType : deliveryType;
      if ((selectPUTimeFirst) && takeAwayInfo && (takeAwayInfo.phone || isEnabled(skipCustomerDetail) || shouldSkipPickUpForm(takeAwayDeliveryType))) {
        confirmTKCheckOut(takeAwayInfo.customerName || "", takeAwayInfo.phone || "",
          takeAwayInfo.scheduleTime || moment().valueOf(), takeAwayInfo.address || "", takeAwayInfo.remark || "",
          takeAwayInfo.checkbox || [], takeAwayDeliveryType, takeAwayInfo.roomNo || "");

        return;
      }


      if (isPreOrder) {
        setShowTk(true);
        return;
      } else if ((deliveryOrNot && hasTakeAway) || (includeDineIn && !tkDiMenuDiff)) { //商家是否开通外卖 
        return setShowDelive(true); // 询问TakeAway or delivery
      } else {
        let selectedDeliveryType = deliveryType;
        if (!includeDineIn || !tkDiMenuDiff) {
          if (reserveData && reserveData != null) {
            selectedDeliveryType = 4;
            setDeliveryType(4);
          } else if (deliveryOrNot) {
            selectedDeliveryType = 2;
            setDeliveryType(2);
          } else if (hasTakeAway) {
            selectedDeliveryType = 0;
            setDeliveryType(0);
          }
        }
        if (shouldSkipPickUpForm(selectedDeliveryType)) {
          confirmTKCheckOut("", "", moment().valueOf(), "", "", [], selectedDeliveryType, "");
          return;
        }
        return setShowTk(true);  // 填写联系方式
      }
    } else { // dine in
      if (!isPreOrder && hasPayment && !PaymentTakeawayOnly) { // Payment Integration
        if (haveToPayOnline && !payAtCounter && !advocadoStoreCredit && !hasFomoPay) {//必须 paynow
          confirmPTCheckOut(0);
        } else {
          setShowPayment(true); //询问paynow or paylater
        }
      } else { // 去付款
    
        setShowConfirm(true)
      };
    }
  }

  //confirm message
  const confirmToCheckout = async () => {
    setLoading(true);
    let order = {
      pax: pax,
      data: cart,
      orderId: "SO_" + new Date().getTime(),
      customerName: name,
      phone: phone,
      roomNo: room,
      userId: userId,
      adCustomer,
      customer,
      reserveId: reserveData ? reserveData.reservationId : "",
      deliveryType: deliveryType,
      vouchers: vouchers,
      deliveryPrice
    };
    await sendOrderToServer(order);
  }

  //online payment, Will transfer to new page
  const confirmPTCheckOut = async (payType, nm, ph, rm, selectedDeliveryType = deliveryType) => {
    addPayType(payType);
    if (payType == 0 || payType == 3) {
      //double check if totalAmount is greater than minConsumption
      if (isOnlinePayMinConsumption && subtotal < onlinePayMinConsumptionVal) {
        setError([{
          errorElement: language[lanIndex].belowMinSpendning,
          errorMessage: (
            <b style={{ color: "#CF000D" }}>{language[lanIndex].belowMinSpending2}<br />
              {language[lanIndex].belowMinSpending3 + " " + currencySymbol + onlinePayMinConsumptionVal.toFixed(2)}</b>
          )
        }])
        setShow(true);
        return;
      }
      setLoading(true);
      let order = {
        pax: pax,
        data: cart,
        orderId: "SO_" + new Date().getTime(),
        userId: userId,
        adCustomer,
        customer,
        reserveId: reserveData ? reserveData.reservationId : "",
        deliveryType: selectedDeliveryType,
        vouchers,
        scheduleTime: takeAwayInfo.scheduleTime ? takeAwayInfo.scheduleTime : "",
        deliveryPrice: deliveryPrice,
        customerName: nm !== undefined ? nm : name,
        phone: ph !== undefined ? ph : phone,
        roomNo: rm !== undefined ? rm : room,
      };
      await sendOrderToPayment(order, false, payType);
    } else if (payType == 2) {
      //need to check if customer has login, bla bla bla
      if (adCustomer && adCustomer != null) {
        setShowAdvocadoCredit(true);
      } else {
        setShowAdvocadoLogin(true);
      }
    } else { //pay later
      setShowConfirm(true)
    }
  }

  //takeaway checkout after confirm delivery
  const confirmTKCheckOut = async (customerName, phone, scheduleTime, address, remark, checkbox, deliveryType, roomNo, postal, unit, addressLine) => {
    if (!validateCartAvailability(scheduleTime)) return;
   
    takeAwayInfo.customerName = customerName;
    takeAwayInfo.phone = phone;
    takeAwayInfo.scheduleTime = scheduleTime;
    takeAwayInfo.address = address;
    if (postal !== undefined) takeAwayInfo.postal = postal;
    if (unit !== undefined) takeAwayInfo.unit = unit;
    if (addressLine !== undefined) takeAwayInfo.addressLine = addressLine;
    takeAwayInfo.remark = remark;
    takeAwayInfo.checkbox = checkbox;
    takeAwayInfo.roomNo = roomNo;
    takeAwayInfo.deliveryType = deliveryType;
    setDeliveryType(deliveryType);
    setTkType(deliveryType);
    addTakeAwayInfo(takeAwayInfo);
    setRoom(roomNo);
    setName(customerName);
    setPhone(phone);

    if (isInRoom) {
      if (payAtCounter || takeAwayAllowAtCounter || hasFomoPay) {
        setShowPayment(true);
      } else {
        confirmPTCheckOut(0, customerName, phone, roomNo, deliveryType);
      }
    } else if (hasPayment && !isPreOrder) {
      if (takeAwayAllowAtCounter || hasFomoPay) {
        setShowPayment(true);
        return;
      }
      setLoading(true);
      let order = {
        pax: pax,
        data: cart,
        orderId: "SO_" + new Date().getTime(),
        customerName,
        phone, userId,
        scheduleTime,
        address, remark,
        checkbox, deliveryType,
        deliveryPrice,
        adCustomer,
        roomNo,
        customer, reserveId: reserveData ? reserveData.reservationId : "", vouchers
      };
      await sendOrderToPayment(order);
    } else {
      setLoading(true);
      let order = {
        pax: pax, data: cart, orderId: "SO_" + new Date().getTime(), customerName, phone, userId,
        scheduleTime, address, remark, checkbox, deliveryType, deliveryPrice, adCustomer,
        customer, reserveId: reserveData ? reserveData.reservationId : "", vouchers,
        roomNo
      };

      await sendOrderToServer(order);
    };
  }

  const confirmDelivery = async (selectedDeliveryType = deliveryType) => {
    if (minimumConsumption != 0 && subtotal < minimumConsumption && selectedDeliveryType == 2) { // Minimum Consumption tip
      return minimumConsumptionTip();
    }
    if (shouldSkipPickUpForm(selectedDeliveryType)) {
      confirmTKCheckOut("", "", moment().valueOf(), "", "", [], selectedDeliveryType, "");
      return;
    }
    setShowTk(true);
  }

  //redirect to online payment
  const sendOrderToPayment = async (order, isAdvocadoPayment = false, selectedPayType = 0) => {
    try {
      order = { ...getOrderContact({}, takeAwayInfo), ...order };
      if (!canSubmit) return;
      if (order && order.scheduleTime && !validateCartAvailability(order.scheduleTime, order.data ? order.data : cart)) return;
      document.cookie = `orderId=${order.orderId}; path=/`;
      document.cookie = `token=${token}; path=/`;
      localStorage.setItem("orderId", order.orderId);
      savePendingOrder(order, takeAwayInfo, { payType: selectedPayType, isAdvocadoPayment });
      addPayType(selectedPayType);
      payByAdvocado(isAdvocadoPayment);
      setFinalOrder(order);
      localStorage.setItem("shouldRedirect", "YES");
      if (finalAmount + deliveryPrice > 0) {
        navigate('/payment');
      } else {
        setShowConfirm(true);
      }
    } catch (error) {
      setError([{ errorMessage: 'Unable to prepare your order. Please try again.' }]);
      setShow(true);
    } finally {
      setLoading(false);
    }
  }

  const sendOrderToServer = async (order) => {
    order = { ...getOrderContact({}, takeAwayInfo), ...order };
    if (!canSubmit) { setLoading(false); return; }
    document.cookie = `orderId=${order.orderId}; path=/`;
    document.cookie = `token=${token}; path=/`;
    if (order && order.scheduleTime && !validateCartAvailability(order.scheduleTime, order.data ? order.data : cart)) { setLoading(false); return; }
    await axios.post("/v2/api/selfOrder/order", order, { timeout: 30000, headers: { Authorization: "Bearer " + token } })
      .then(async function (response) {
        await axios.get(`/v2/api/selfOrder/order?userId=${userId}&orderTime=${orderTime}&orderId=${order.orderId}`,
          { timeout: 30000, headers: { Authorization: "Bearer " + token } }
        );
      })
      .then(function (response) {
        // handle success
        localStorage.setItem("orderId", order.orderId);
        clearCart();
        setLoading(false);
        let newPromo = pm;
        newPromo = newPromo.filter((p) => !p.isVoucher);
        addPromotion(newPromo);
        //if fomo paynow, need to convert paymentPlatform to 5
        addPayType(payType);
        //push to success page
        navigate('/payment/success');
      })
      .catch(function (response) {
        // handle error
        setLoading(false);
        navigate('/order/fail');
      
      });


  }

  const advocadoVerificationSubmit = async () => {
    setLoading(true);
    let order = {
      pax: pax,
      data: cart,
      orderId: "SO_" + new Date().getTime(),
      userId: userId,
      adCustomer, customer,
      reserveId: reserveData ? reserveData.reservationId : "",
      deliveryType,
      vouchers,
      deliveryPrice: deliveryPrice,
      customerName: name,
      phone: phone,
      roomNo: room,
    };
    payByAdvocado(true);
    await sendOrderToPayment(order, true, 2);
  }

  useEffect(() => {
   
    if (takeAwayInfo) {
      if (takeAwayInfo.deliveryPrice > 0 && selectPUTimeFirst) {
        setDeliveryPrice(takeAwayInfo.deliveryPrice);
      }
      if (takeAwayInfo.phone !== undefined) {
        setPhone(takeAwayInfo.phone);
      }
      if (takeAwayInfo.customerName !== undefined) {
        setName(takeAwayInfo.customerName);
      }
      if (takeAwayInfo.roomNo !== undefined) setRoom(takeAwayInfo.roomNo);

    }
  }, [takeAwayInfo, selectPUTimeFirst]);

  useEffect(() => {
    //after stock checking
    if (isStockCheck) {
      sendOrder();
    }
  }, [isStockCheck])

  useEffect(() => {
    if (deliveryType == 0 || deliveryType == 1 || deliveryType == 4) {

      if (!selectPUTimeFirst)
        setDeliveryPrice(0);
      return;
    }
    //here to determine
    if (deliveryCalMethod == 0) {
      deliveryCosts.forEach((item) => {
        if (subtotal >= item.minPrice && item.maxPrice > subtotal) {
          setDeliveryPrice(item.deliveryPrice);
        }
      })
    } else if (selectPUTimeFirst) {
      const baseDeliveryPrice = Number(takeAwayInfo.deliveryBasePrice ?? takeAwayInfo.deliveryPrice) || 0;
      const deliveryDiscount = Number(finalAmount) >= Number(deliverySpend)
        ? Number(deliveryDisAmt) || 0
        : 0;
      setDeliveryPrice(Math.max(0, baseDeliveryPrice - deliveryDiscount));
    }
  }, [subtotal, finalAmount, deliveryType, deliveryCalMethod, deliveryCosts, deliveryDisAmt, deliverySpend, selectPUTimeFirst, takeAwayInfo]);

  useEffect(() => {

    //reset all voucher promo
    for (let c of cart) {
      c.hasSpecialDiscount = false;
      c.specialDiscount = 0;
      c.specialDiscountAmount = 0;
      c.specialDiscountRemark = "";

    }
    setDefaultAmount(promo.subTotalDefaultAmount(cart));
    setSubtotal(promo.subTotalAmount(cart));

  }, [cart]);

  useEffect(() => {
    let order = readStoredJSON("order");
    let postal = localStorage.getItem("postal");
    if (postal) {
      addPostal(postal);
    }
    if (Array.isArray(order)) {
      addToCart(order);
    }
  }, [addToCart]);

  useEffect(() => {
    const reserveData = readStoredJSON("reserveData");
    const savedOrder = finalOrder || readStoredJSON("finalOrder");

    if (reserveData && (!savedOrder || savedOrder.reserveId === reserveData.reservationId)) {
      setReserveData(reserveData);
      if (savedOrder?.deliveryType === undefined) setDeliveryType(4);
    }
  }, [setReserveData]);


  // Calculate the service charge before tax using the existing discount and takeaway rules.
  const amountBeforeTax = promo.getFinalAmount(
    cart, "", serviceCharge, { ...tax, taxMode: 0, tax: 0 },
    paymentData, isTakeAway, deliveryType
  );
  const serviceChargeAmount = amountBeforeTax - subtotal - bcrsNo * 0.1;
  const taxAmount = finalAmount - amountBeforeTax;
  if (typeof lanIndex === 'undefined') {
    return <></>
  }
  return (
    <React.Fragment>
      <CheckoutBackdrop onClick={() => navigate('/menu')} />
      <BackgroundColor themeContext={themeContext}>
        {isLoading ? (
          <OrderLoading />
        ) : (
          <React.Fragment>
            <CheckoutButton
              type="button"
              disabled={!canSubmit}
              buttonWidth={checkoutWidth - 28}
              themeContext={themeContext}
              onClick={sendOrder}
              active={true}
            >
              <span>{hasPayment && !PaymentTakeawayOnly ?
                language[lanIndex].submitAndPay : language[lanIndex].submit}</span>
              {!hidePrice && <span>{canSubmit ? `${currencySymbol}${(deliveryPrice + finalAmount).toFixed(2)}` : 'Calculating total…'}</span>}
            </CheckoutButton>
            <HeaderContainer
              themeContext={themeContext}
              headerHeight={themeContext.headerHeight}
            >
            </HeaderContainer>
            <ArrowContainer themeContext={themeContext} headerHeight={themeContext.headerHeight}>
              <Link
                to="/menu"
                style={{ display: "grid", placeContent: "center" }}
              >
                <IoIosArrowBack
                  color={themeContext.checkOutArrow}
                  size={themeContext.headerHeight}
                />
              </Link>
            </ArrowContainer>

            <MenuTitleContainer
              headerHeight={themeContext.headerHeight}
              themeContext={themeContext}
            >{language[lanIndex].cart}</MenuTitleContainer>

            <Buffer height={themeContext.headerHeight + 30} />
            {!isPreOrder && !isTakeAway && deliveryType == 4 &&
              <ReserveInfo />
            }
            {!isPreOrder && !isTakeAway && deliveryType !== 4 &&
              <TableInfo />
            }
            {isPreOrder &&
              <PreOrderInfo />
            }

            <React.Fragment>
              {width < 768 &&
                <CheckoutRecommendationItems
                  recommendation={checkoutRecommendation}
                  cart={cart}
                  onSelectItem={handleRecommendedItemClick}
                />
              }
              <CartSummary themeContext={themeContext}>
                <div><strong>{lanIndex == 1 ? `购物车共 ${cart.reduce((sum, item) => sum + Number(item.qty || 0), 0)} 件` : `${cart.reduce((sum, item) => sum + Number(item.qty || 0), 0)} items in cart`}</strong><span>{lanIndex == 1 ? "本轮" : "This round"}</span></div>
                <p>{lanIndex == 1 ? "发送到厨房前请核对您的订单。" : "Review your order before sending to the kitchen."}</p>
              </CartSummary>
              {cart.map((item, index) => {
                return (
                  <CheckoutPanel
                    key={index + item.title + item.codeId}
                    cart={cart}
                    handleDelete={handleDelete}
                    handleAdd={handleAdd}
                    handleMinus={handleMinus}
                    handleItemClick={handleItemClick}
                    index={index}
                    item={item}
                    height={height}
                    width={checkoutWidth}
                    lanIndex={lanIndex}
                    isLanReverse={isLanReverse}
                    currencySymbol={currencySymbol}
                    deleteActive={true}
                    hidePrice={hidePrice}
                  />
                );
              })}
              <Buffer height={250} />
              {!hidePrice &&
                <SubTotalWrapper width={checkoutWidth - 20} themeContext={themeContext}>
                  {hasVoucher && !advocadoRedeem && !memberRedeem &&
                    //voucher promo area
                    <SubtotalAndTaxContainer
                      themeContext={themeContext}
                      width={checkoutWidth - 40}
                    >
                      <VoucherField />
                    </SubtotalAndTaxContainer>
                  }
                  <SubtotalAndTaxContainer
                    themeContext={themeContext}
                    width={checkoutWidth - 40}
                  >
                    <LeftColumn>
                      {language[lanIndex].subtotal}
                    </LeftColumn>
                    <RightColumn>
                      {currencySymbol}&nbsp;{(defaulAmount * (displayNetAmount ? (1 + (tax.taxMode == 0 ? tax.tax : 0)) : 1)).toFixed(2)}
                    </RightColumn>

                  </SubtotalAndTaxContainer>
                  {defaulAmount != subtotal &&
                    <SubtotalAndTaxContainer
                      themeContext={themeContext}
                      width={checkoutWidth - 40}
                    >
                      <LeftColumn>
                        {language[lanIndex].discount}
                      </LeftColumn>
                      <RightColumn>
                        {currencySymbol}&nbsp;{((subtotal - defaulAmount) * (displayNetAmount ? (1 + (tax.taxMode == 0 ? tax.tax : 0)) : 1)).toFixed(2)}
                      </RightColumn>

                    </SubtotalAndTaxContainer>
                  }
                  {serviceChargeAmount > 0 &&
                    <SubtotalAndTaxContainer
                      themeContext={themeContext}
                      width={checkoutWidth - 40}
                    >
                      <LeftColumn>
                        {language[lanIndex].serviceCharge}
                      </LeftColumn>
                      <RightColumn>
                        {currencySymbol}&nbsp;{serviceChargeAmount.toFixed(2)}
                      </RightColumn>
                    </SubtotalAndTaxContainer>
                  }
                  {taxAmount > 0 &&
                    <SubtotalAndTaxContainer
                      themeContext={themeContext}
                      width={checkoutWidth - 40}
                    >
                      <LeftColumn>
                        {language[lanIndex].tax}
                      </LeftColumn>
                      <RightColumn>
                        {currencySymbol}&nbsp;{taxAmount.toFixed(2)}
                      </RightColumn>
                    </SubtotalAndTaxContainer>
                  }

                  {deliveryType == 2 &&
                    <SubtotalAndTaxContainer
                      themeContext={themeContext}
                      width={checkoutWidth - 40}
                    >
                      <LeftColumn>
                        {language[lanIndex].deliveryFee}
                      </LeftColumn>
                      <RightColumn>
                        {currencySymbol}&nbsp;{deliveryPrice.toFixed(2)}
                      </RightColumn>
                    </SubtotalAndTaxContainer>}
                  {bcrsNo > 0 &&
                    <SubtotalAndTaxContainer
                      themeContext={themeContext}
                      width={checkoutWidth - 40}
                    >
                      <LeftColumn>
                        BCRS
                      </LeftColumn>
                      <RightColumn>
                        {currencySymbol}&nbsp;{(bcrsNo * 0.1).toFixed(2)}
                      </RightColumn>
                    </SubtotalAndTaxContainer>}

                  <TotalContainer themeContext={themeContext} width={checkoutWidth - 40}>
                    <LeftColumn>
                      {language[lanIndex].total}
                    </LeftColumn>
                    <RightColumn>
                      {currencySymbol}&nbsp;{(deliveryPrice + finalAmount).toFixed(2)}
                    </RightColumn>
                  </TotalContainer>
                </SubTotalWrapper>
              }
            </React.Fragment>

          </React.Fragment>
        )}

        <Modal show={show} setShow={setShow} error={error} />
        <ConfirmCheckOutModal show={showConfirm} setShow={setShowConfirm} confirmCheckOut={confirmToCheckout} lanIndex={lanIndex} />
        <TakeAwayModal show={showTk} setShowTk={setShowTk} deliveryType={deliveryType} confirmTKCheckOut={confirmTKCheckOut}
          setDeliveryPrice={setDeliveryPrice} deliveryPrice={deliveryPrice} lanIndex={lanIndex} totalAmount={finalAmount} currencySymbol={currencySymbol} />
        <DeliveryOrNotModal show={showDelive} setShowDelive={setShowDelive} type={deliveryType} setDeliveryType={setDeliveryType} deliveryOrNot={deliveryOrNot}
          confirmDelivery={confirmDelivery} lanIndex={lanIndex} deliveryPrice={deliveryPrice} currencySymbol={currencySymbol} includeDineIn={includeDineIn}
          tkDiMenuDiff={tkDiMenuDiff} hasTakeAway={hasTakeAway}
          setDeliveryPrice={setDeliveryPrice}
        />
        <PaymentTypeModal show={showPayment} setShow={setShowPayment} payType={payType} setPayType={setPayType} lanIndex={lanIndex}
          payAtCounter={payAtCounter} confirmPTCheckOut={confirmPTCheckOut} total={(deliveryPrice + subtotal).toFixed(2)} />
        {showEdit &&
          <EditItemModal show={showEdit} item={editItem} index={editIndex} setShow={setShowEdit} cart={cart} />
        }
        {showRecommendedItem && recommendedItem &&
          <AddItemModal
            show={showRecommendedItem}
            setShow={setShowRecommendedItem}
            item={recommendedItem}
            handleAddItem={addRecommendedItemToCart}
            confirmLabel={language[lanIndex].addToCart}
          />
        }
        {showAdvocadoLogin &&
          <AdvocadoLogin
            show={showAdvocadoLogin}
            setShow={setShowAdvocadoLogin}
            handleCallback={() => {
              setShowAdvocadoLogin(false);
              setShowAdvocadoCredit(true);
            }}
          />
        }
        {showAdvocadoCredit &&
          <AdvocadoCredit
            setShow={setShowAdvocadoCredit}
            show={showAdvocadoCredit}
            totalAmount={finalAmount}
            handleCallback={advocadoVerificationSubmit}
          />
        }
      </BackgroundColor>
    </React.Fragment>
  );
};

export default Checkout;

//Styled Components
const CheckoutBackdrop = styled.div`
  display: none;

  @media (min-width: 768px) {
    display: block;
    position: fixed;
    inset: 0;
    z-index: 998;
    background: rgba(0, 0, 0, 0.38);
    animation: checkoutBackdropIn 180ms ease-out;

    @keyframes checkoutBackdropIn {
      from { opacity: 0; }
      to { opacity: 1; }
    }
  }
`;

const BackgroundColor = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100dvh;
  width: 100vw;
  max-width: 550px;
  background-color: ${(props) => props.themeContext.backgroundColor};
  overflow-y: scroll;
  z-index: 999;

  @media (min-width: 768px) {
    right: 0;
    left: auto;
    width: min(420px, 92vw);
    max-width: none;
    box-shadow: -14px 0 38px rgba(0, 0, 0, 0.22);
    animation: checkoutDrawerIn 220ms cubic-bezier(0.22, 1, 0.36, 1);

    @keyframes checkoutDrawerIn {
      from {
        transform: translateX(100%);
        opacity: 0.65;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }
  }
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: fixed;
  width: 100vw;
  max-width: 550px;
  top: 0rem;
  flex-direction: column;
  height: ${(props) => props.headerHeight + 10}px;
  background-color: ${(props) => props.themeContext.secondaryColor};
  z-index: 5;
  box-shadow: 0px 1px 3px rgba(0,0,0, 45%);

  @media (min-width: 768px) {
    right: 0;
    left: auto;
    width: min(420px, 92vw);
    max-width: none;
    z-index: 5;
  }
`;

const ArrowContainer = styled.div`
  position: fixed;
  place-content: center;
  z-index: 10;
  width: 60px;
  height: ${(props) => props.headerHeight + 10}px;
  display: flex;

  @media (min-width: 768px) {
    left: auto;
    right: calc(min(420px, 92vw) - 60px);
    z-index: 10;
  }
`;

const CheckoutButton = styled.button`
  display: ${props => props.active ? "flex" : "none"};
  position: fixed;
  bottom: calc(10px + env(safe-area-inset-bottom, 0px));
  z-index: 3;
  box-sizing: border-box;
  width: ${props => props.buttonWidth}px;
  margin-left: 14px;
  min-height: 48px;
  padding: 12px 20px;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  border: 0;
  border-radius: 999px;
  color: ${props => actionTextColor(props.themeContext)};
  background: ${props => props.themeContext.primaryColor};
  font-family: ${props => props.themeContext.fontFamily};
  font-size: 15px;
  font-weight: 600;
  text-align: left;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  span:last-child { white-space: nowrap; }
  &:focus-visible { outline: 2px solid ${props => props.themeContext.primaryColor}; outline-offset: 3px; }
  @media (min-width: 768px) {
    right: 14px;
    margin-left: 0;
  }
`;


const MenuTitleContainer = styled.div`
  position: fixed;
  font-size: 16px;
  font-weight: bold;
  color: ${(props) => props.themeContext.checkOutArrow};
  font-family: ${(props) => props.themeContext.fontFamily};
  margin-left: 48px;
  display: flex;
  align-items: center;
  height: ${(props) => props.headerHeight + 10}px;
  z-index: 5;

  @media (min-width: 768px) {
    right: 0;
    width: min(420px, 92vw);
    box-sizing: border-box;
    margin-left: 0;
    padding-left: 60px;
    z-index: 5;
  }
`;

const Buffer = styled.div`
  display: block;
  height: ${(props) => props.height}px;
`;

const SubTotalWrapper = styled.div`
  position: fixed;
  bottom: 0px;
  padding: 8px 20px;
  padding-bottom: 60px;
  background: white;
  border-top: 1px solid;
  background-color: ${(props) => props.themeContext.backgroundColor};

  @media (min-width: 768px) {
    right: 0;
    width: min(420px, 92vw);
    box-sizing: border-box;
    z-index: 2;
  }
`;

const SubtotalAndTaxContainer = styled.div`
  display: flex;
  color: ${(props) => props.themeContext.fontPrimary};
  font-family: ${(props) => props.themeContext.fontFamily};
  width: ${(props) => props.width}px;
  font-weight: 500;
  font-size: 14px;
  padding-bottom: 4px;
`;

const LeftColumn = styled.div`
  flex-grow: 1;
`;

const RightColumn = styled.div`
  text-align: right;
`;

const TotalContainer = styled.div`
  display: flex;
  /*color: ${(props) => props.themeContext.fontPrice};*/
  font-family: ${(props) => props.themeContext.fontFamily};
  
  width: ${(props) => props.width}px;
  font-weight: 700;
  font-size: 18px;
`;

const CartSummary = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 550px;
  margin: 0 auto;
  padding: 14px;
  text-align: left;
  color: ${props => readableText(props.themeContext.backgroundColor, props.themeContext.fontPrimary)};
  font-family: ${props => props.themeContext.fontFamily};
  border-bottom: 1px solid ${props => lightTint(props.themeContext.primaryColor, 0.2)};
  div { display: flex; gap: 8px; align-items: center; font-size: 15px; }
  span { padding: 3px 8px; border-radius: 999px; font-size: 10px; background: ${props => lightTint(props.themeContext.primaryColor)}; color: ${props => readableText(lightTint(props.themeContext.primaryColor), props.themeContext.primaryColor)}; }
  p { margin: 6px 0 0; font-size: 12px; line-height: 1.4; }
`;
